import {
  Button,
  Container,
  ImageList,
  ImageListItem,
  Typography,
} from "@mui/material";
import logo from "../../images/assets/LOGO 2027.png";

const galleryImages = [
  "homepage11.jpg",
  "homepage1.jpg",
  "homepage10.jpg",
  "homepage9.jpg",
  "homepage8.jpg",
  "homepage3.jpg",
  "homepage7.jpg",
  "homepage6.jpg",
  "homepage5.jpg",
  "homepage4.jpg",
  "homepage2.jpg",
];

function Landing() {
  return (
    <div className="home">
      <div className="home-tickets">
        <Container maxWidth="xl">
          <div className="modal-content">
            <div className="line-up-container-image">
              <img src={logo} className="landing-logo" alt="mpf logo" />
              <Typography className="title landing-title" variant="h6">
                Manchester Psych Fest 2027
              </Typography>
              <Typography className="title landing-title" variant="h6">
                Saturday 4th September
              </Typography>
              < br/>
              <Typography className="title landing-title" variant="h6">
                Early birds - sold out
              </Typography>
              <Typography className="title landing-title" variant="h6">
                2nd tier tickets on sale now
              </Typography>
              <Typography className="title landing-title" variant="h6">
                <span>*plus booking fees</span>
              </Typography>
            </div>
          </div>
          <div className="home-tickets-container">
            <Button
              href="https://manchesterpsychfest.seetickets.com/event/manchester-psych-fest-2027/various-venues/3707606"
              color="secondary"
              size="large"
              variant="contained"
              sx={{
                color: "white",
                marginTop: "20px",
                fontSize: "28px",
                padding: "10px 70px",
                borderColor: "white",
                textAlign: "center",
              }}
              target="_blank"
            >
              Buy Tickets
            </Button>

            <Button
              href="/2026"
              color="secondary"
              size="large"
              variant="contained"
              className="ticket-header-button"
              sx={{
                color: "white",
                marginTop: "20px",
                fontSize: "28px",
                padding: "10px 70px",
                borderColor: "white",
                textAlign: "center",
              }}
              target="_blank"
            >
              2026 Website
            </Button>
            <Button
              href="https://hikerdelic.com/collections/hikerdelic-x-psychfest"
              color="secondary"
              size="large"
              variant="contained"
              className="ticket-header-button"
              sx={{
                color: "white",
                marginTop: "20px",
                fontSize: "28px",
                padding: "10px 70px",
                borderColor: "white",
                textAlign: "center",
              }}
              target="_blank"
            >
              Hikerdelic Collab
            </Button>
          </div>

          <ImageList variant="masonry" cols={3} gap={8} className="image-list">
            {galleryImages.map((item) => {
              const imageFile = require(`../../images/assets/${item}`);

              return (
                <ImageListItem key={item.img}>
                  <img
                    srcSet={`${imageFile}?w=248&fit=crop&auto=format&dpr=2 2x`}
                    src={`${imageFile}?w=248&fit=crop&auto=format`}
                    alt={item.title}
                    loading="lazy"
                  />
                </ImageListItem>
              );
            })}
          </ImageList>
        </Container>
      </div>
    </div>
  );
}
export default Landing;
